// extracted by mini-css-extract-plugin
export var closeButton = "_44-0";